import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom'
import { AuthProvider, useAuth } from './context/AuthContext'
import { DeviceStatusProvider } from './context/DeviceStatusContext'
import { AdminDataProvider } from './context/AdminDataContext'
import ProtectedRoute from './components/ProtectedRoute'
import Layout from './components/Layout'
import Login from './pages/Login'
import Overview from './pages/Overview'
import DeviceMonitor from './pages/DeviceMonitor'
import ClientsHub from './pages/ClientsHub'
import Firmware from './pages/Firmware'
import SystemHub from './pages/SystemHub'
import DeviceDetail from './pages/DeviceDetail'
import InventoryHub from './pages/InventoryHub'
import InvoicesHub from './pages/InvoicesHub'
import TicketsHub from './pages/TicketsHub'
import CalendarHub from './pages/CalendarHub'
import PipelineHub from './pages/PipelineHub'
import GoalsHub from './pages/GoalsHub'
import MoreHub from './pages/MoreHub'
import AuditHub from './pages/AuditHub'
import FinanceHub from './pages/FinanceHub'
import NotificationsHub from './pages/NotificationsHub'
import AdminUsersHub from './pages/AdminUsersHub'
import EmailMarketingHub from './pages/EmailMarketingHub'
import SocialMediaHub from './pages/SocialMediaHub'
import ResellersHub from './pages/ResellersHub'
import ResellerPortal from './pages/ResellerPortal'
import ResellerApply from './pages/ResellerApply'
import MiDashboard from './pages/MiDashboard'
import UpdateBanner from './components/UpdateBanner'
import './App.css'

/**
 * Layout route protegido — envuelve todas las rutas hijas
 * con ProtectedRoute + Layout + DeviceStatusProvider.
 * WebSocket solo conecta después del login.
 */
function ProtectedLayout() {
  return (
    <ProtectedRoute>
      <DeviceStatusProvider>
        <AdminDataProvider>
          <Layout>
            <Outlet />
          </Layout>
        </AdminDataProvider>
      </DeviceStatusProvider>
    </ProtectedRoute>
  )
}

/**
 * Index page — muestra ResellerPortal para resellers, Overview para admins
 */
function IndexPage() {
  const { isReseller } = useAuth()
  return isReseller ? <ResellerPortal /> : <Overview />
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <UpdateBanner />
        <Routes>
          {/* Ruta pública de login */}
          <Route path="/login" element={<Login />} />

          {/* Ruta pública de registro de revendedor */}
          <Route path="/revendedor" element={<ResellerApply />} />

          {/* Rutas protegidas con layout compartido */}
          <Route element={<ProtectedLayout />}>
            <Route index element={<IndexPage />} />
            <Route path="/mi-dashboard" element={<MiDashboard />} />
            <Route path="/devices" element={<DeviceMonitor />} />
            <Route path="/devices/:mac" element={<DeviceDetail />} />
            <Route path="/clients" element={<ClientsHub />} />
            <Route path="/firmware" element={<Firmware />} />
            <Route path="/system" element={<SystemHub />} />
            <Route path="/inventory" element={<InventoryHub />} />
            <Route path="/invoices" element={<InvoicesHub />} />
            <Route path="/tickets" element={<TicketsHub />} />
            <Route path="/calendar" element={<CalendarHub />} />
            <Route path="/pipeline" element={<PipelineHub />} />
            <Route path="/goals" element={<GoalsHub />} />
            <Route path="/tools" element={<MoreHub />} />
            <Route path="/audit" element={<AuditHub />} />
            <Route path="/finance" element={<FinanceHub />} />
            <Route path="/notifications" element={<NotificationsHub />} />
            <Route path="/admin-users" element={<AdminUsersHub />} />
            <Route path="/email-marketing" element={<EmailMarketingHub />} />
            <Route path="/social-media" element={<SocialMediaHub />} />
            <Route path="/resellers" element={<ResellersHub />} />
            {/* Reseller portal routes */}
            <Route path="/my-sales" element={<ResellerPortal />} />
            <Route path="/my-payouts" element={<ResellerPortal />} />
            <Route path="/my-link" element={<ResellerPortal />} />
            <Route path="/my-profile" element={<ResellerPortal />} />
            <Route path="/my-tools" element={<ResellerPortal />} />
            {/* Legacy redirects */}
            <Route path="/diagnostics" element={<Navigate to="/devices" replace />} />
            <Route path="/logs" element={<Navigate to="/system" replace />} />
            <Route path="/analytics" element={<Navigate to="/" replace />} />
            <Route path="/subscriptions" element={<Navigate to="/clients" replace />} />
            <Route path="/cost-monitoring" element={<Navigate to="/system" replace />} />
          </Route>

          {/* Redirección por defecto */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  )
}

export default App
